import * as React from 'react'
import { ISystemBase } from '../types/ISystemBase';
import { SystemBase } from '../common/SystemBase';

//import * as moment from 'moment'

interface ISystemLabel {
    value: any
}


export const calculateAge = (dateOfBirth?: Date) => {
    if (!dateOfBirth) return "";

    var year = dateOfBirth.getFullYear();
    var month = dateOfBirth.getMonth();
    var day = dateOfBirth.getDay();
    var today = new Date();

    var ageYears = today.getFullYear() - year;
    var ageMonths = Math.abs(today.getMonth() - month);

    if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
        ageYears--;
    }

    return {year, month, day, ageYears, ageMonths }
}

export default class SystemAge extends SystemBase<ISystemLabel>
{
    constructor(props: ISystemLabel) {
        super(props)
    }
    render() {
        var dateOfBirth: Date = typeof this.props.value == "string" ? new Date(this.props.value) : this.props.value
        if (!dateOfBirth) return "";
        var year = dateOfBirth.getFullYear();
        var month = dateOfBirth.getMonth();
        var day = dateOfBirth.getDay();
        var today = new Date();
        var ageYears = today.getFullYear() - year;
        var ageMonths = Math.abs(today.getMonth() - month);
        if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
            ageYears--;
        }
      //  return `${month + 1}/${day}/${year} ${ageYears} years ${ageMonths} months`;


        //let fromDate = moment(from.toISOString())
        //let toDate = moment();
        //let years = toDate.diff(fromDate, 'years')
        //fromDate.add(years, 'years')
        //let months = toDate.diff(fromDate, 'months')
        //fromDate.add(months, 'months')
        //let days = toDate.diff(fromDate, 'days')

        let age = '';
        if (!(ageYears === 0)) { age = ageYears + (ageYears > 1 ? ' years ' : ' year ') }
        if (!(ageMonths === 0)) { age = age + ageMonths + (ageMonths > 1 ? ' months ' : ' month ') }
       // if (!(days === 0)) { age = age + days + (days > 1 ? ' days ' : ' day ') }

        return (
            <this.WrapperDiv>
                <span className="font-weight-bolder">{age}</span>
            </this.WrapperDiv>
        );
    }
}